import React, { useMemo } from "react";



export const LeagueTableDataRow = ({ columns, data, ...rest }) => {
    const pounds = Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0, 
        minimumFractionDigits: 0,
    });
    const { adviserName, adviserLeagueTableValues } = data || { adviserLeagueTableValues: [] };
    return <tr {...rest}>
        <td>{adviserName}</td>
        {columns.map((el, i) => <td key={i} className="text-end">{adviserLeagueTableValues.find(r => r.elementDescription === el.property)? (isNaN(adviserLeagueTableValues[i].elementValue)? 'n/a': pounds.format(adviserLeagueTableValues[i].elementValue)) : pounds.format(0)}</td>)}
        {/*{columns.map((el, i) => <td key={i} className="text-end">{adviserLeagueTableValues.find(r => r.elementDescription === el.property).elementValue ?? pounds.format(0)}</td>)}*/}
    </tr>
};

export const LeagueTableEmptyRow = ({ colspan = 1, ...rest }) => {
    return <tr {...rest}>
        <td colSpan={colspan}>Your search did not yield any results.</td>
    </tr>
};

export const LeagueTableLoadingRow = ({ colspan = 1, ...rest }) => {
    return <tr {...rest}>
        <td colSpan={colspan}>Loading...</td>
    </tr>
};

export const LeagueTableTotalsRow = ({ columns, data, ...rest }) => {
    const pounds = Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0, 
        minimumFractionDigits: 0,
    });
    const summaryColumns = useMemo(() => {
        return columns.map(el => {
            let colTotal = 0;
            for (var i = 0; i < data.length; i++) {
                const { adviserLeagueTableValues } = data[i];
                const adviserLeagueTableValue = adviserLeagueTableValues.find(tc => tc.elementDescription === el.property);

                if (adviserLeagueTableValue) {
                    colTotal += adviserLeagueTableValue.elementValue;
                }
            }

            return {
                ...el,
                totalCount: pounds.format(colTotal)
            };
        });
    }, [ columns, data ]);

    return <tr {...rest}>
        <td>Totals</td>
        {summaryColumns.map((el, i) => <td key={i} className="text-end">{el.totalCount}</td>)}
    </tr>
};

const LeagueTable = ({ label = "", data = [], error = null, isLoading = false, showTotals = true }) => {
    const columns = useMemo(() => {
        if (data.length < 1 || !data[0].adviserLeagueTableValues || data[0].adviserLeagueTableValues.length < 1) {
            return [];
        }
        let retval = [];
        let firstCounts = data[0].adviserLeagueTableValues;
        
        for (var i = 0; i < firstCounts.length; i++) {
            retval.push({ label: firstCounts[i].elementDescription, property: firstCounts[i].elementDescription });
        }
        return retval;
    }, [ data ]);
    
    return <div className="table-responsive">
        <table className="table">
            <thead>
                <tr>
                    <th>{label}</th>
                    {columns.map((el, i) => <th key={el.property} className="text-end">{el.label}</th>)}
                </tr>
            </thead>
            <tbody>
                {isLoading === true && <LeagueTableLoadingRow colspan={columns.length} />}
                {isLoading === false && !error && data.length === 0 && <LeagueTableEmptyRow colspan={columns.length} />}
                {isLoading === false && !error && data && data.map((el, _) => <LeagueTableDataRow key={el.adviserId} columns={columns} data={el} />)}
            </tbody>
            {isLoading === false && !error && data && data.length > 0 && showTotals && (
                <tfoot className="fw-bold">
                    <LeagueTableTotalsRow columns={columns} data={data} />
                </tfoot>
            )}
        </table>
    </div>
};

export default LeagueTable;